import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryContact} from "@/service/contact.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";
import {useQueryUser} from "@/service/user.s";
import Chip from "@mui/material/Chip";

export const ViewMember = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: userData, isLoading: userLoading} = useQueryUser({id: drawerId!}, isNumber(drawerId))
    const user = userData?.data
    return <> <ResultWrapper isLoading={userLoading} isEmpty={isEmpty(user)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'名称'} content={user?.username}/>
                <GridItem title={'联系电话'} content={user?.mobile}/>
                <GridItem title={'性别'} content={user?.gender == 1 && '男' || user?.gender == 2 && '女' || "未知"}/>
                <GridItem title={'审核状态'} content={<Chip variant={'outlined'} color={user?.statusId == 2 ? 'success' : 'warning'} label={user?.status}/>}/>
                <GridItem minHeight={'48px'} size={12} title={'备注说明'} content={user?.remark || '-'}/>
                <GridItem title={'更新时间'} content={formatTime('D', user?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', user?.createdAt)}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}